import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import CustomModal from './CustomModal';
import OnTraccrButton from '../buttons/OnTraccrButton';
import DisplayText from '../text/DisplayText';

import colors from '../../constants/Colors';
import CustomModalRedesigned from './CustomModalRedesigned';

export default function SimpleFormModal({
  title,
  visible,
  onClose,
  onSave,
  errorText,
  disabled,
  children,
  width,
  useRedesign,
  saveText = 'Save',
}) {
  const [loading, setLoading] = useState(false);

  const onCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const onSaveClicked = useCallback(async () => {
    setLoading(true);
    await onSave();
    setLoading(false);
  }, [onSave]);

  const ModalComponent = useRedesign ? CustomModalRedesigned : CustomModal;

  return (
    <ModalComponent
      title={title}
      visible={visible}
      hideCloseButton={!useRedesign}
      maskColor={colors.MODAL_MASK_DARK}
      width={width}
      onCloseClicked={onClose}
    >
      <Row style={{ margin: useRedesign ? '0px 0px 20px 0px' : '20px 5px' }}>
        {children}
      </Row>
      <Row justify="center" gutter={12} style={{ marginBottom: useRedesign ? 0 : 10 }}>
        <Col span={12}>
          <OnTraccrButton
            type="cancel"
            title="Cancel"
            roundStyle={!useRedesign}
            onClick={onCancel}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={12}>
          <OnTraccrButton
            title={saveText}
            roundStyle={!useRedesign}
            disabled={disabled}
            onClick={onSaveClicked}
            loading={loading}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
      {errorText && (
        <Row>
          <DisplayText
            style={{
              color: 'red',
              height: 'auto',
              opacity: 1,
            }}
            title={errorText}
          />
        </Row>
      )}
    </ModalComponent>
  );
}

SimpleFormModal.propTypes = {
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.number,
  children: PropTypes.node,
  useRedesign: PropTypes.bool,
  saveText: PropTypes.string,
};

SimpleFormModal.defaultProps = {
  visible: false,
  errorText: '',
  disabled: false,
  width: 400,
  children: null,
  useRedesign: false,
  saveText: 'Save',
};
